import { Header } from "../../components/Header"
import { Form } from "../../components/Form"

function Checkout() {
  return (
      <div>
        <Header />
        <Form />
      </div>
  );
}

export default Checkout;